"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Cross.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Cross = function Cross(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 31.02 32.02"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "line-icon-cross"), _react2.default.createElement("path", {
    className: "cross",
    d: "M18.26 16L30.44 3.42a2 2 0 0 0 0-2.83 1.89 1.89 0 0 0-2.67-.07l-.07.07-12.18 12.59L3.33.59A1.89 1.89 0 0 0 .66.52L.59.59a2 2 0 0 0 0 2.83L12.77 16 .59 28.6a2 2 0 0 0 0 2.83 1.89 1.89 0 0 0 2.67.07l.07-.07 12.19-12.59L27.7 31.43a1.89 1.89 0 0 0 2.67.07l.07-.07a2 2 0 0 0 0-2.83z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Cross;